import jwtService from 'app/services/jwtService';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';

import { hideSplashScreen } from './splashScreen';
import { setUserData, logoutUser } from './store/userSlice';

function handleLoginWithAccess(accessId) {
  return jwtService
    .signInWithAccess(accessId)
    .then((user) => ({ user }))
    .catch((error) => ({ error: error.message }));
}

function handleLoginWithToken() {
  return jwtService
    .signInWithToken()
    .then((user) => ({ user }))
    .catch((error) => {
      if (error?.status === 4000) jwtService.logout();

      return { error: error.message };
    });
}

function Auth(props) {
  const [state, setState] = useState({ waitAuthCheck: true });
  const dispatch = useDispatch();

  useEffect(() => {
    async function handleAutoLogin(accessId) {
      if (accessId) {
        // TODO: Remove this commit after Connect V1 is deprecated
        const { user, error } = await handleLoginWithAccess(accessId);
        if (user) dispatch(setUserData(user));
        if (error) dispatch(showMessage({ message: error }));
      } else {
        const { user, error } = await handleLoginWithToken();
        if (user) dispatch(setUserData(user));
        if (error) dispatch(showMessage({ message: error }));
      }

      setState({ waitAuthCheck: false });
    }

    function handleAutoLogout(message) {
      if (message) {
        dispatch(showMessage({ message }));
      }

      dispatch(logoutUser());

      setState({ waitAuthCheck: false });
    }

    function handleNoAccessToken() {
      setState({ waitAuthCheck: false });
    }

    jwtService.on('onAutoLogin', handleAutoLogin);
    jwtService.on('onAutoLogout', handleAutoLogout);
    jwtService.on('onNoAccessToken', handleNoAccessToken);

    jwtService.init();

    return () => {
      jwtService.removeListener('onAutoLogin', handleAutoLogin);
      jwtService.removeListener('onAutoLogout', handleAutoLogout);
      jwtService.removeListener('onNoAccessToken', handleNoAccessToken);
    };
  }, [dispatch]);

  // index.html's splash screen covers the page until the token check is done
  useEffect(() => {
    if (!state.waitAuthCheck) hideSplashScreen();
  }, [state.waitAuthCheck]);

  return state.waitAuthCheck ? null : props.children;
}

export default Auth;
